import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';

const routes: Routes = [{
  path: '',
  component: MainComponent,
  data: {
    meta: {
      title: 'Marco Rubber | O-Ring Supplier Experts | Buy Viton®',
      description: "O-Rings Seals Gasket Manufacturer Supplier, Expert Fast Service, Interactive Online Ordering, Giant Inventory of Standard and Custom O-Rings"
    }
  }
}];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class MainRoutingModule { }
